import { AssemblerWizard } from '../assembler/AssemblerWizard';
import { useAccount } from '../../context/AccountContext';

export function AssemblerLayout() {
  const { accountId, isLoading: loading } = useAccount();

  const renderBody = () => {
    if (loading) {
      return (
        <div className="flex-1 flex items-center justify-center text-cmp-ink-2">
          Loading assembler…
        </div>
      );
    }
    if (!accountId) {
      return (
        <div className="flex-1 flex items-center justify-center text-cmp-ink-2">
          No account found.
        </div>
      );
    }
    return <AssemblerWizard accountId={accountId} />;
  };

  return (
    <div className="ink-page flex w-full flex-col h-full min-h-0 overflow-hidden">
      <div className="flex flex-col flex-1 min-h-0 overflow-y-auto md:overflow-hidden">
        <div className="w-full max-w-full overflow-hidden relative flex-1 flex flex-col">
          <div className="m-0 w-full h-full relative overflow-hidden box-border bg-primary-background flex flex-col">
            <div className="ink-frame">{renderBody()}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
